import styled from 'styled-components';

import { breakpoints } from  '../../../styles/variables';
import { SH1 } from '../../atoms/Typography/H1/styles';
import { SText } from '../../atoms/Typography/Text/styles';

export const SHeroContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    max-width: 72rem;

    @media (min-width: ${ breakpoints.medium }) {
        justify-content: space-between;
        flex-direction: row;
        align-items: flex-start;
    }

    @media (min-width: ${ breakpoints.big }) {
        max-width: 100%;
    }
`;

export const SHeroContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 54rem;

    @media (min-width: ${ breakpoints.medium }) {
        align-items: flex-start;
        max-width: 70rem;
    }
`;

export const SHeroHeader = styled(SH1)`
    margin: 0 0 1.6rem;
    max-width: 45rem;
    text-align: center;

    @media (min-width: ${ breakpoints.medium }) {
        text-align: left;
        max-width: 60rem;
        margin-bottom: 2.4rem;
        font-size: 6rem;
        line-height: 7.2rem;
    }

    @media (min-width: ${ breakpoints.big }) {
        margin: 2.4rem 0;
    }

    @media (min-width: ${ breakpoints.large }) {
        margin-top: 6rem;
        font-size: 7.2rem;
        max-width: 100%;
        line-height: 8.6rem;
    }
`;

export const SHeroSubheader = styled(SText)`
    font-family: "Gilroy", sans-serif;
    font-weight: 800;
    max-width: 50rem;
    margin-bottom: 1.6rem;
    font-size: 2.4rem;
    line-height: 3.2rem;
    letter-spacing: -1px;
    text-align: center;

    @media (min-width: ${ breakpoints.medium }) {
        margin-bottom: 2.4rem;
        text-align: left;
        font-size: 2.4rem;
        line-height: 3.2rem;
        max-width: 62rem;
    }
`;

export const SHeroText = styled(SText)`
    font-family: "Gilroy", sans-serif;
    font-weight: 600;
    font-size: 1.6rem;
    line-height: 2.4rem;
    letter-spacing: -.3px;
    text-align: center;
    margin: 0;
    display: inline;

    @media (min-width: ${ breakpoints.medium }) {
        text-align: left;
        display: block;
    }
`;

export const SHeroGraphic = styled.div`
    position: relative;
    display: flex;
    flex-shrink: 0;
    width: 40rem;
    height: 40rem;
    
    @media (min-width: ${ breakpoints.medium }) {
        margin-top: -2rem;
    }

    @media (min-width: ${ breakpoints.large }) {
        width: 60rem;
        height: 60rem;
    }
`;

export const SGraphicBox = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
`;
